/* eslint-disable */
import React from "react";
import "./CenterFeatureSection.css";

function CenterFeatureSection() {
  return (
    <section className="center-feature">
      <h2 className="section-title">
        Why Partner with <br /> Afghan Dry Fruit Delights?
      </h2>

      <div className="feature-layout">
        {/* LEFT FEATURES */}
        <div className="features left">
          <div className="feature-item">
            <h4>Unmatched Quality</h4>
            <p>
              We ensure the highest quality standards through trusted farms and
              processing facilities.
            </p>
          </div>

          <div className="feature-item">
            <h4>Global Network</h4>
            <p>
              Serving Central Asia, Middle East, Europe, and the USA with strong
              partnerships.
            </p>
          </div>

          <div className="feature-item">
            <h4>Sustainably Sourced</h4>
            <p>
              We work closely with farmers and local communities.
            </p>
          </div>
        </div>

        {/* CENTER IMAGE */}
        <div className="center-image">
          <img
            src="images/slides/center.png"
            alt="Dry Fruits"
          />
        </div>

        {/* RIGHT FEATURES */}
        <div className="features right">
          <div className="feature-item">
            <h4>Health & Wellness</h4>
            <p>
              Naturally rich in nutrients to promote a healthy lifestyle.
            </p>
          </div>

          <div className="feature-item">
            <h4>Trusted Wholesale Supplier</h4>
            <p>
              Reliable supply chain solutions for clients worldwide.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CenterFeatureSection;
